import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import tinycolor from "tinycolor2";

const ManagerSidebarContainer = (props) => {
  var { data, showLegacyCases } = props;
  const dipColor = tinycolor(data).darken(10).toString();

  const mangerId = localStorage.getItem("ManegerId");
  const userid = mangerId;
  const imagepath =
    `${process.env.REACT_APP_API_URL}/GetImageById?UserId=` + userid;

  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");

  useEffect(() => {
    LoadUser();
  }, []);

  const LoadUser = () => {
    const datavalue = {
      Usetid: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getManagerById`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      //console.log("get value", res);
      //console.log("list", res.data[0]?.first_Name);

      setfirstname(res.data[0]?.first_Name);
      setlastname(res.data[0]?.last_Name);
    });
  };

  return (
    <>
      {/* <!-- start sidebar menu --> */}
      <div className="sidebar-container">
        <div className="sidemenu-container navbar-collapse collapse fixed-menu">
          <div
            id="remove-scroll"
            className="left-sidemenu"
            style={{ "background-color": data }}
          >
            <ul
              className="sidemenu  page-header-fixed slimscroll-style"
              data-keep-expanded="false"
              // data-auto-scroll="true" data-slide-speed="200" style="padding-top: 20px">
              data-auto-scroll="true"
              data-slide-speed="200"
            >
              <li className="sidebar-toggler-wrapper hide">
                <div className="sidebar-toggler">
                  <span></span>
                </div>
              </li>
              <li className="sidebar-user-panel">
                <div className="sidebar-user">
                  <div className="sidebar-user-picture">
                    {/* <img alt="image" src="img/dp.jpg" /> */}
                    <img
                      src={imagepath}
                      style={{ width: "50px" }}
                      alt="image"
                    />
                  </div>
                  <div className="sidebar-user-details">
                    {/* <div className="user-name">Dr. Kiran Patel</div> */}
                    <div className="user-role">
                      <a style={{ color: "#FFF" }}>{firstname}</a> <a style={{ color: "#FFF" }}>{lastname}</a>
                    </div>
                  </div>
                </div>
              </li>
              <li className="nav-item start active open">
                <a
                  href="#"
                  className="nav-link nav-toggle"
                  style={{ "background-color": data }}
                >
                  <i data-feather="airplay" style={{ color: "#FFF" }}></i>

                  <Link to="/index">
                    <span className="title" style={{ color: "#FFF" }}>Dashboard</span>
                  </Link>
                </a>
              </li>
              <li className="nav-item start">
                <a
                  href="#"
                  className="nav-link nav-toggle"
                  style={{ "background-color": data }}
                >
                  {/* <i data-feather="smile"></i> */}
                  <i data-feather="user" style={{ color: "#FFF" }}></i>
                  <span className="title" style={{ color: "#FFF" }}>Cases</span>
                  <span className="selected" style={{ color: "#FFF" }}></span>
                  <span className="arrow" style={{ color: "#FFF" }}></span>
                </a>
                <ul
                  className="sub-menu"
                  style={{ "background-color": dipColor }}
                >
                  <li className="nav-item">
                    <Link to="/AddManagerPatient" className="nav-link">
                      <span className="title" style={{ color: "#FFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/ManagerPatientList" className="nav-link">
                      <span className="title" style={{ color: "#FFF" }}>List</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/ChatGptList">
                      <span className="title" style={{ color: "#FFF" }}>Logs</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/DeberiefingList">
                      <span className="title" style={{color: "#FFFFFF"}}>Performance Logs</span>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item start">
                <a
                  href="#"
                  className="nav-link nav-toggle"
                  style={{ "background-color": data }}
                >
                  <i data-feather="slack" style={{ color: "#FFF" }}></i>
                  <span className="title" style={{ color: "#FFF" }}>Multi Character Cases</span>
                  <span className="selected" style={{ color: "#FFF" }}></span>
                  <span className="arrow" style={{ color: "#FFF" }}></span>
                </a>
                <ul
                  className="sub-menu"
                  style={{ "background-color": dipColor }}
                >
                  <li className="nav-item">
                    <Link to="/AddManagerScenario" className="nav-link">
                      <span className="title" style={{ color: "#FFF" }}>Add</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/ScenarioList" className="nav-link">
                      <span className="title" style={{ color: "#FFF" }}>List</span>
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link to="/ChatGptScenarioList" className="nav-link">
                      <span className="title" style={{ color: "#FFF" }}>Logs</span>
                    </Link>
                  </li>
                  {/* <li className="nav-item  ">
                    <Link to="/ScenarioDeberiefingList" className="nav-link">
                      <span className="title" style={{color: "#FFFFFF"}}>Deberiefing Logs</span>
                    </Link>
                  </li> */}
                </ul>
              </li>


              {showLegacyCases == null ? showLegacyCases = true : showLegacyCases = showLegacyCases}
              {showLegacyCases &&

                <li className="nav-item start">
                  <a
                    href="#"
                    className="nav-link nav-toggle"
                    style={{ "background-color": data }}
                  >
                    {/* <i data-feather="smile"></i> */}
                    <i data-feather="user" style={{ color: "#FFF" }}></i>
                    <span className="title" style={{ color: "#FFF" }}>Cases (Legacy)</span>
                    <span className="selected" style={{ color: "#FFF" }}></span>
                    <span className="arrow" style={{ color: "#FFF" }}></span>
                  </a>
                  <ul
                    className="sub-menu"
                    style={{ "background-color": dipColor }}
                  >
                    <li className="nav-item">
                      <Link to="/LAddManagerPatient" className="nav-link">
                        <span className="title" style={{ color: "#FFF" }}>Add</span>
                      </Link>
                    </li>
                    <li className="nav-item  ">
                      <Link to="/LManagerPatientList" className="nav-link">
                        <span className="title" style={{ color: "#FFF" }}>List</span>
                      </Link>
                    </li>
                  </ul>
                </li>
              }

              <li className="nav-item start active open">
                <a
                target="_blank"
                  href="https://vimeo.com/showcase/10538430"
                  className="nav-link nav-toggle"
                  style={{ "background-color": data }}
                >
                  <i data-feather="help-circle" style={{ color: "#FFF" }}></i>

                  <span className="title" style={{ color: "#FFF" }}>Tutorial</span>
                </a>
              </li>
              {/* <li className="nav-item start">
                                <a href="#" className="nav-link nav-toggle" style={{ "background-color": props.data}}>
                                    <i data-feather="file-plus"></i>
                                    <span className="title">Intents</span>
                                    <span className="selected"></span>
                                    <span className="arrow"></span>
                                </a>
                                <ul className="sub-menu" style={{ "background-color": dipColor}}>
                                    <li className="nav-item">
                                        <Link to='/ManMasterIntent' className='nav-link'>
                                            <span className="title">Add</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item  ">
                                        <Link to='/ManMasterIntentList' className='nav-link'>
                                            <span className="title">List</span>
                                        </Link>
                                    </li>

                                </ul>
                            </li>
                            <li className="nav-item start">
                                <a href="#" className="nav-link nav-toggle" style={{ "background-color": props.data}}>
                                    <i className='fa-question'></i>
                                    <span className="title">Global Questions</span>
                                    <span className="selected"></span>
                                    <span className="arrow"></span>
                                </a>
                                <ul className="sub-menu" style={{ "background-color": dipColor}}>
                                    <li className="nav-item">
                                        <Link to='/ManIntentAns' className='nav-link'>
                                            <span className="title">Add</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item  ">
                                        <Link to='/ManIntentList' className='nav-link'>
                                            <span className="title">List</span>
                                        </Link>
                                    </li>

                                </ul>
                            </li> */}
              {/* <li className="nav-item start">
                <a
                  href="#"
                  className="nav-link nav-toggle"
                  style={{ "background-color": data }}
                >
                  <i className="fa fa-indent" style={{color: "#FFF"}}></i>

                  <Link to="/ChatGptList">
                    <span className="title" style={{color: "#FFF"}}>Logs</span>
                  </Link>
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
      {/* <!-- end sidebar menu --> */}
      {/* <!-- start page content --> */}
    </>
  );
};

export default ManagerSidebarContainer;
